<template>
  
  <div>
    <div class="text-right">
      <template>
        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-toolbar color="transparent" flat>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                medium
                color="primary"
                v-bind="attrs"
                v-on="on"
                class="pl-2 ma-1"
                @click="New()"
              >
                <v-icon>mdi-plus</v-icon>
                NEW
              </v-btn>

              <v-btn
                medium
                outlined
                color="error"
                @click="Reload()"
                class="pl-2"
                >VIEW</v-btn
              >
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="editItem(item)"
            >
              <v-icon left>mdi-pencil</v-icon>
              Edit
            </v-btn>
            <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="setupItem(item)"
            >
              <v-icon left>mdi-cog-outline</v-icon>
              Setup
            </v-btn>

            <!-- <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              v-on="on"
              class="ma-1"
              @click="LoginDetail(item)"
            >
              <v-icon left>mdi-account</v-icon>
              File Uplaod
            </v-btn> -->
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-navigation-drawer
        v-model="sheet"
        right
        persistent
        temporary
        fixed
        style="width: 100%; max-width: 800px; margin: auto"
      >
        <v-sheet class="text-center" min-height="200px">
          <div class="py-3 text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryMode }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="red darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.event_name"
                        label="Event Name*"
                        outlined
                        dense
                        required
                        :rules="VCardName"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.email_subject"
                        label="Event Subject*"
                        outlined
                        dense
                        required
                        :rules="VCardName"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.event_date"
                        label="Event Date*"
                        outlined
                        dense
                        required
                        :rules="VCardName"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.email_sender"
                        label="Email Sender"
                        outlined
                        dense
                        required
                        :rules="VCardName"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.event_url"
                        label="Event URL"
                        outlined
                        dense
                        required
                        :rules="VCardName"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-select
                        :items="template_item"
                        v-model="SeltemplateID"
                        label="Template ID"
                        dense
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>



                     <v-col cols="12" sm="6" md="12">
                      <v-select
                        :items="MediaTemplate_item"
                        v-model="MediaSeltemplateID"
                        label="Media Template ID"
                        dense
                        outlined
                        hide-details
                      ></v-select>
                    </v-col>




                    <v-col cols="12" sm="6" md="12">
                      <v-select
                        :items="banner_item"
                        v-model="selBannerID"
                        dense
                        label="Banner Type"
                        hide-details
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-select
                        :items="item_import"
                        v-model="selImported"
                        dense
                        label="Do you want Import ?"
                        hide-details
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col v-if="this.selImported=='Y'" cols="12" sm="6" md="12">
                      <v-select
                        outlined
                        v-model="SelEvent"
                        :items="EventName"
                        item-text="event_name"
                        item-value="event_id"
                        label="Select Event"
                        dense
                        :rules="[(v) => !!v || 'Event is required']"
                        required
                        hide-details
                        full-width
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>

                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="save"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>
    </div>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>


  


  </div>




  
</template>






<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
//import { ref } from 'vue'
//const dialog = ref(false)



export default {

  data() {
    return {
      //dialog:false,
      selImported:"",
      EventName: [],
      SelEvent:0,
      SeltemplateID: "",
      MediaSeltemplateID: "",
      selBannerID: "",
      snackbar: false,
      snackbartext: "",
      snackbarcolor: "primary",
      EntryMode: "",
      valid: false,
      mode: "NEW",
      newmode: true,
      sheet: false,
      search: "",
      loadingstatus: false,
      cardID: "",
      postBody: {
        event_name: "",
        email_subject: "",
        email_sender: "",
        event_date: "",
        event_url: "",
        banner_type: "",
        template_id: 0,
        media_template_id: 0,
        is_import:"",
        import_from:0
      },
      
      template_item: [
        { text: "ICC", value: 5 },
        { text: "PKL", value: 2 },
        { text: "LFW", value: 1 },
        { text: "PKL WITHOUT IDs", value: 6 },
        { text: "ILT20", value: 7 },
        { text: "DNA Event", value: 3 },
      ],


     MediaTemplate_item: [
        { text: "ICC", value: 5 },
        { text: "PKL", value: 2 },
        { text: "LFW", value: 1 },
        { text: "PKL WITHOUT IDs", value: 6 },
        { text: "ILT20", value: 7 },
        { text: "DNA Event", value: 3 },
      ],

      banner_item: [
        { text: "I", value: "I" },
        { text: "V", value: "V" },
      ],
      item_import: [
        { text: "Yes", value: "Y" },
        { text: "No", value: "N" },
      ],
      headers: [
        {
          text: "event_id",
          align: "left",
          sortable: false,
          value: "event_id",
        },
        { text: "Name", value: "event_name", align: "left" },
        { text: "Date", value: "event_date", align: "left" },
        { text: "URL Name", value: "event_url", align: "left" },

        { text: "Actions", value: "actions", sortable: false, align: "right" },
      ],
      desserts: [],
      VCardName: [
        (v) => !!v || "Event Name is required",
        // v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
    };
  },


 
  mounted() {
    this.$store.commit("setPageTitle", "Event Master");
    this.bindEvent();
    this.Reload();
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },




    Reload: function () {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          console.log(this.desserts);
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },
    New() {
      this.EntryMode = "New Event";
      this.postBody.event_name = "";
      this.sheet = true;
    },
    editItem(item) {
      // this.EntryMode = "Edit Card";
      // this.postBody.card_name = item.event_name;
      this.EntryMode = "Edit Event";
      this.cardID = item.event_id;
      this.postBody.event_name = item.event_name;
      this.postBody.email_subject = item.email_subject;
      this.postBody.event_date = item.event_date;
      this.postBody.email_sender = item.email_sender;
      this.postBody.event_url = item.event_url;
      this.SeltemplateID = item.template_id;
      this.MediaSeltemplateID = item.media_template_id;
      this.selBannerID = item.banner_type;

      this.selImported = item.isImport;
      this.SelEvent = item.import_from_event;


      this.sheet = true;
    },
    setupItem(item) {
      //  this.$store.commit("setPageTitle", item.event_name);
      console.log("Get Data",item);
      this.$store.commit("setEventInfo", item);
      this.$router.push("/admin/EditEvents");
    },

    LoginDetail(item) {
      this.$store.commit("setEventInfo", item);
      this.$router.push("/admin/users");
    // dialog.value=true;
    },

    deleteItem(item) {
      //alert(item.Vendor_Id);
      const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this Card?")) {
        axios
          .delete(this.$apiPath + "event/" + item.event_id, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
            // this.desserts = res.data.result;
            this.showSnackbar("Success", "Card Deleted !");
            this.Reload();
          })
          .catch()
          .finally();
      }
      this.desserts.splice(index, 1);
      this.Reload();
    },

    bindEvent: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.EventName = res.data.result;
        })
        .catch()
        .finally();
    },

    close() {
      this.sheet = false;
      this.Reload();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.$refs.form.validate();
      this.postBody.template_id = this.SeltemplateID;
      this.postBody.media_template_id = this.MediaSeltemplateID;
      this.postBody.banner_type = this.selBannerID;
this.postBody.is_import=this.selImported;

this.postBody.import_from=this.SelEvent;

      console.log("hi");
      console.log(this.postBody);
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
        if (this.EntryMode == "New Event") {
          axios
            .post(this.$apiPath + "event", this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "Event Created!");
                this.Reload();
              }
            })
            .catch()
            .finally();
        } else {
          // this.postBodyUpdate.Vendor_Name = this.postBody.Vendor_Name; //Object.assign({}, item)

          axios
            .put(this.$apiPath + "event/" + this.cardID, this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "Card Updated!");
                this.Reload();
              }
            })
            .catch()
            .finally();
        }
      }
      this.close();
    },
  },
};
</script>

<style>
</style>